<template>
<div class="h-100 w-100">
  <swiper ref="TypeSwiper" id="type-swiper" :options="swiperOption" @slideChange="slideChange">
    <swiper-slide class="slider-item-spacer">
      <div>
        TYPE
      </div>
    </swiper-slide>
    <swiper-slide v-for="i of productSectionLength" :key="i" class="slider-item-product">
      <div class="col-product">
        <ProductCell :product="products[isMobile().phone? (i-1): (i-1)*2]" :typeId="types[typeArrayIndex].id"/>
        <div class="mt-4" v-if="!isMobile().phone && products.length > (i-1)*2+1">
          <ProductCell :product="products[(i-1)*2+1]" :typeId="types[typeArrayIndex].id"/>
        </div>

        <!-- <div class="row mt-4" v-if="!isMobile.phone && products.length > (i-1)*2+1">
          <div class="col-md-6">
            <img class="img-fluid" :src="products[(i-1)*2+1]._embedded['wp:featuredmedia'][0].source_url">
          </div>
          <div class="col-md-6">
            <ul class="list-unstyled font-size-0_7rem">
              <li v-for="typeId in products[(i-1)*2+1].type_note" :key="'type_note-'+typeId" :class="productTypeClass(typeId)">
                {{ typeName(typeId) }}
              </li>
            </ul>

            <h6 class="h4">{{ brandName(products[(i-1)*2+1].brand[0]) }}</h6>
            <h5 class="h6 mb-4">{{ products[(i-1)*2+1].title.rendered }}</h5>
            <a :href="products[(i-1)*2+1].acf.shop_url" target="_blank" class="btn btn-layered py-2">
              <span class="py-2">official onlineStore</span>
              official onlineStore
            </a>
          </div>
        </div> -->
      </div>
    </swiper-slide>
  </swiper>
</div>
</template>

<script>
import isMobile from 'ismobilejs'
import {mapState, mapActions} from 'vuex'
import ProductCell from '@/components/ProductCell'

export default {
  name: 'Type',
  components: {
    ProductCell
  },
  props: {
    typeArrayIndex: {
      type: String,
      defalut: '1',
    }
  },
  data(){
    return {
      isMobile,
      typeData: null,
      products: [],
      swiperOption: {
        direction: 'horizontal',
        slidesPerView: 'auto',
        freeMode: true,
        spaceBetween: 50,
        mousewheel: true,
      },
    }
  },
  mounted() {
    this.setTypeArrayIndex(this.typeArrayIndex)

    if(!this.types) {
      console.log('typeないよ')
      this.fetchTypes()
    } else {
      console.log('typeあるよ')
      this.getProducts()
    }

    if (this.typeNavigationShowing && isMobile().phone) {
      setTimeout(() => {
        this.setTypeNavigationShowing(false)
      }, 1000);
    }
  },
  computed: {
    ...mapState({
      types: state => state.types,
      brands: state => state.brands,
      typeNavigationShowing: state => state.typeNavigationShowing
    }),
    productSectionLength(){
      if (this.isMobile().phone) {
        return this.products.length
      } else {
        return Math.ceil(this.products.length * 0.5)
      }
    }
  },
  watch: {
    types (newVal, oldVal) {
      if(newVal && !oldVal) {
        this.typeData = this.types[this.typeArrayIndex]
        this.getProducts()
      }
    }
  },
  methods: {
    ...mapActions({
      syncBrands: 'syncBrands',
      syncTypes: 'syncTypes',
      setTypeArrayIndex: 'doSetTypeArrayIndex',
      setTypeNavigationShowing: 'doSetTypeNavigationShowing'
    }),
    async fetchTypes() {
      await this.syncTypes(this.axios)
    },
    async fetchBrands() {
      await this.syncBrands(this.axios)
    },

    async getProducts() {
      const payload = await this.axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/wp/v2/product?type_note=' + this.types[parseInt(this.typeArrayIndex)].id + '&per_page=100&_embed')
        .catch((e) => {
          alert(e);
        });
      console.log(payload)
      if (payload.data) {
        // this.$set(this, 'news', payload.data)
        this.products = payload.data
      }
    },
    productTypeClass(typeId) {
      if (typeId == this.types[this.typeArrayIndex].id) {
        return ''
      } else {
        return 'text-muted'
      }
    },
    brandName(brandId) {
      // console.log('brandId', brandId)
      for(let i=0; i<this.brands.length; i++) {
        if (this.brands[i].id == brandId) {
          return this.brands[i].name
        }
      }
      return ''
    },
    typeName(typeId) {
      // console.log('typeId', typeId)
      for(let i=0; i<this.types.length; i++) {
        if (this.types[i].id == typeId) {
          return this.types[i].name
        }
      }
      return '' + typeId
    },
    slideChange() {
      this.setTypeNavigationShowing(this.$refs.TypeSwiper.$swiper.activeIndex == 0)
    },

  }
}
</script>

<style lang="scss">
#type-swiper {
  height: 100%;
  .swiper-slide {
    display: flex;
    align-items: center;
    width: 340px;
    margin-right: 50px;
    &.slider-item-brand {
      width: 340px;
    }
    &.slider-item-product {
      width: 250px;
      @media screen and (min-width: 768px) {
        width: 464px;
      }
    }
    &.slider-item-spacer {
      width: 140px;
      @media screen and (min-width: 768px) {
        width: 300px;
      }
      color: #fff;
    }
    >div {
      height: 460px;
    }
  }
}
.col-product {
  width: 250px;
  @media screen and (min-width: 768px) {
    width: 540px;
  }
}
</style>

